export default __webpack_public_path__ + "static/media/Rockstar_Stamp.8af18abb.png";